import React from "react";
import { useNavigate } from "react-router-dom";
import { Box, Paper, Typography, Badge } from "@mui/material";
import { ShoppingCart } from "@mui/icons-material";
import { useOrder } from "../context/OrderContext";
import { formatPrice, orderItemCount, orderTotal } from "../utils/helpers";
import { useSession } from "../context/SessionContext";
import { NAV_HEIGHT } from "./MainLayout";

// Only shown for the not-yet-placed cart — once the order is live it's
// already visible on the "My Order" tab (with its own badge), so this bar
// would just be a redundant second way to reach the same screen.
export default function BottomCartBar() {
  const navigate = useNavigate();
  const { currency } = useSession();
  const { order, isCart } = useOrder();

  const count = orderItemCount(order);
  if (!isCart || count === 0) return null;

  return (
    <Paper
      elevation={6}
      onClick={() => navigate("/cart")}
      sx={{
        position: "fixed",
        left: 16,
        right: 16,
        bottom: NAV_HEIGHT + 16,
        p: 1.5,
        borderRadius: 3,
        bgcolor: "primary.main",
        color: "primary.contrastText",
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
        cursor: "pointer",
        zIndex: 10,
      }}
    >
      <Box sx={{ display: "flex", alignItems: "center", gap: 1.5 }}>
        <Badge badgeContent={count} color="default" sx={{ "& .MuiBadge-badge": { bgcolor: "#fff", color: "primary.main" } }}>
          <ShoppingCart />
        </Badge>
        <Typography fontWeight={700}>View Cart</Typography>
      </Box>
      <Typography fontWeight={700}>{formatPrice(orderTotal(order), currency)}</Typography>
    </Paper>
  );
}
